export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Інформація про контрагента"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Рахунок / E-mail / Телефон"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Крипто-адреса / E-mail / Телефон"])}
}